// src/services/weatherService.js

import axios from "axios";
import { interpretWeatherApiError } from "../utils/interpretWeatherApiErrors";

// Wir speichern die Basis-URL der WetterAPI
const BASE_URL = "https://api.weatherapi.com/v1";
// Unser API-Key (dieser sollte später aus einer .env-Datei kommen)
const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

/**
 * Holt aktuelle Wetterdaten für eine Stadt
 * @param {string} city - Der Name der Stadt (z. B. "Berlin")
 * @returns {Promise<Object>} - JSON-Antwort der API
 */
export const fetchWeatherData = async (city) => {
  try {
    const response = await axios.get(`${BASE_URL}/current.json`, {
      params: { key: API_KEY, q: city, aqi: "no" },
    });
    return response.data;
  } catch (error) {
    const errorCode = error?.response?.data?.error?.code;
    const errorMessage = interpretWeatherApiError(errorCode);
    throw new Error(errorMessage); // Wird in App.js abgefangen
  }
};

/**
 * Holt Wettervorhersage für eine Stadt (inkl. Stunden, Sonnenaufgang etc.)
 * @param {string} city
 * @param {number} days – Anzahl der Vorhersage-Tage (max 10)
 */
export const fetchForecastData = async (city, days = 1) => {
  try {
    const response = await axios.get(`${BASE_URL}/forecast.json`, {
      params: {
        key: API_KEY,
        q: city,
        days: days,
        aqi: "no",
        alerts: "no",
      },
    });

    return response.data;

  } catch (error) {
    console.error("Fehler beim Abrufen der Vorhersagedaten:", error);
    return null;
  }
};



